<template>
    <div class="col-lg-3 col-sm-6 mb-xl-0 mb-4 box">
        <div class="card">
            <div class="card-header p-2 ps-3">
            <div class="v-flex justify-content-between">
                <div>
                <p class="text-sm mb-0 text-capitalize">{{ box.title}}</p>
                <h4 class="mb-0"> {{ box.val }} </h4>
                </div>
                <div class="iconwrap">
                <div class="ic"><div v-html="icons[box.icon]"></div></div>
                </div>
            </div>
            </div>
            <hr class="dark horizontal my-0">
            <div class="card-footer p-2 ps-3">
            <p class="mb-0 text-sm">
                <span class="font-weight-bolder" 
                    :style="box.percent < 0 ? {color: 'red'} : {color: 'green'}"> 
                    <span v-if="box.percent >= 0">+</span>{{ box.percent }}%
                </span> 
                {{ box.sub }} 
            </p>
            </div>
        </div>
    </div>
</template>

<script>
import icons from '@/assets/js/icons.js';
import {ref} from 'vue';

export default {
    name:"DashBox",
    props: {
        box: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    setup() {
        const svgIcons = ref(icons);

        return{
            icons: svgIcons.value
        }
        
    },
}
</script>
<style scoped>
.box{padding: 0 calc(1.5rem* 0.5);}
.font-weight-bolder{font-weight: bolder;}
p{color:var(--light-text-color) !important; font-family: Inter, Helvetica, Arial, sans-serif;}
.box > *{padding: 0 calc(1.5rem * 0.5);}
.box .card{background:var(--white-color); border-radius: 0.5rem}
.card-header:first-child {border-radius: 0.5rem 0.5rem 0 0;padding: 0.5rem !important;
  padding-left: 1rem !important;background-color: var(--white-color);
  border-bottom: 0 solid #e5e5e5;}
.iconwrap{border-radius: 0.5rem; width: 48px;height: 48px; background-position: center;
  background-image: var(--black-gradient);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(64, 64, 64, 0.4) !important;
  text-align: center !important; display: flex; align-items: center; justify-content: center;}
.iconwrap .ic{width:18px; height:18px; fill:var(--always-white);line-height: 0em;
    stroke: var(--always-white);}
.text-sm {font-size: 0.875rem !important; line-height: 1.5;}
.text-capitalize {text-transform: capitalize !important;}
h4{font-size: 1.5rem; line-height: 1.375; font-weight: 600;}
hr.horizontal {background-image: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.4), transparent);}
body.dark-mode hr.horizontal{background-image: linear-gradient(90deg, hsla(0, 0%, 100%, 0), #fff, hsla(0, 0%, 100%, 0));}
.my-0 {margin-top: 0 !important; margin-bottom: 0 !important;}
hr.horizontal {background-color: transparent;}
hr {border-top: none; height: 1px;}
hr {color: inherit; border: 0; opacity: 0.25;}
.ps-3 {padding-left: 1rem !important;}
.p-2 {padding: 0.5rem !important;}
</style>